"use client";

import { Container, Row, Col } from "react-bootstrap";
import { IoLayersOutline } from "react-icons/io5";
import { PiDeviceMobileSpeakerLight } from "react-icons/pi";
import { LuInfinity } from "react-icons/lu";
import { AiOutlineThunderbolt } from "react-icons/ai";
import "./WhyChooseSection.scss";

export default function WhyChooseSection() {
  const whyChooseFeatures = [
    {
      id: 1,
      title: "Tailored for Service Businesses",
      description:
        "Make your business grow with a complete set of advanced functions.",
      icon: <IoLayersOutline />,
    },
    {
      id: 2,
      title: "Mobile-First for Field Teams",
      description:
        "Convert and scale seamlessly with built-in marketing and business solutions.",
      icon: <PiDeviceMobileSpeakerLight />,
    },
    {
      id: 3,
      title: "ERP & CRM Integration",
      description:
        "Make your business grow with a complete set of advanced functions.",
      icon: <LuInfinity />,
    },
    {
      id: 4,
      title: "Scalable Cloud Architecture",
      description:
        "Get an enterprise-grade foundation, engineered for your limitless scalability and peace of mind.",
      icon: <LuInfinity />,
    },
    {
      id: 5,
      title: "Powered by 10+ Years of Expertise",
      description:
        "Get an enterprise-grade foundation, engineered for your limitless scalability and peace of mind.",
      icon: <AiOutlineThunderbolt />,
    },
  ];

  return (
    <section className="why-choose-section" id="why">
      <Container>
        <h2 className="why-choose-title">Why Service Connect?</h2>
        <Row className="justify-content-center">
          {whyChooseFeatures.map(({ id, icon, title, description }) => (
            <Col key={id} md={6} lg={4} className="mt-4">
              <div className="whychoose-card">
                <div className="icon-wrapper">{icon}</div>
                <h5 className="choose-title">{title}</h5>
                <p className="choose-description">{description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
